import { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import {
  IAppliedFilter,
  IFilterableField,
} from 'v2/common/ComposeFilters/filters';
import {
  getQueryParametersFromAppliedFilters,
  getApliedFiltersFromQueryParams,
} from 'v2/common/ComposeFilters/utils';
import useGetPageNumber from './useGetPageNumber';
import useQueryParams from './useQueryParams';

export function useAdvancedFilters(
  baseRoute: string,
  _filterableFields: IFilterableField[]
) {
  const location = useLocation();
  const history = useHistory();
  const page = useGetPageNumber({
    onNotValidPageNumber: handleChangePage,
  });

  const queryParams = useQueryParams();
  const currentParams = Object.fromEntries(queryParams.entries());

  const searchText = queryParams.get('search') || '';
  const sortColumn = queryParams.get('sort');

  const initialFilters = getApliedFiltersFromQueryParams(currentParams);

  const [filters, setFilters] = useState<IAppliedFilter[]>(initialFilters);

  const handleChangeSearch = (search: string) => {
    if (search.length === 0 || search.length > 2) {
      const params = new URLSearchParams({ ...currentParams, search });
      history.push({
        pathname: `${baseRoute}/1`,
        search: params.toString(),
      });
    }
  };

  const handleChangeFilters = (newAppliedFilters: IAppliedFilter[]) => {
    const filterParams =
      getQueryParametersFromAppliedFilters(newAppliedFilters);
    const params = new URLSearchParams(filterParams);
    history.push({
      pathname: location.pathname,
      search: params.toString(),
    });
    setFilters(newAppliedFilters);
  };

  const handleChangeSort = (sort: string) => {
    const params = new URLSearchParams({ ...currentParams, sort });
    history.push({
      pathname: location.pathname,
      search: params.toString(),
    });
  };

  function handleChangePage(page: number) {
    history.push({
      pathname: `${baseRoute}/${page}`,
      search: location.search,
    });
    window.scrollTo(0, 0);
  }

  return {
    page,
    filters,
    searchText,
    sortColumn,
    handleChangeFilters,
    handleChangePage,
    handleChangeSort,
    handleChangeSearch,
  };
}
